import { memo, useCallback } from 'react';
import { Color } from '@diritto/common/style/color';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { TrackerExtraInfo, TrackerPosition, TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { useTrackingState } from 'contexts/TrackingProvider';
import { useHomeSettingDispatch, useHomeSettingState } from 'contexts/HomeSettingProvider';
import { HomeSectionViewMode } from 'constants/homeSectionViewMode';
import { CardViewIcon } from 'icons/CardViewIcon';
import { ListViewIcon } from 'icons/ListViewIcon';
import { dispatchHomeViewModeChange } from 'events/homeViewModeEvent';
import { showToast } from 'utils/modal';

const trackerExtraInfo: TrackerExtraInfo = {
  trackerPosition: TrackerPosition.Home,
};

const variant = {
  button: {
    base: 'flex flex-row items-center justify-center py-[2px] rounded-md border-none cursor-pointer transition-colors disabled:cursor-default',
    text: 'text-[11px] leading-[18px] font-[600]',
  },
};

export const HomeSectionViewModeSwitch = memo(function HomeSectionViewModeSwitch() {
  const { tracker } = useTrackingState();
  const { isTextMode } = useHomeSettingState();
  const { changeViewMode } = useHomeSettingDispatch();

  const handleModeChange = useCallback(
    (targetMode: HomeSectionViewMode) => {
      changeViewMode(targetMode);
      localStorage.setItem(LocalStorageKey.ModeGuideFABDismissed, 'true');
      dispatchHomeViewModeChange(targetMode);
      tracker.track(TrackingEventType.ChangeHomeViewMode, {
        viewMode: targetMode,
        trackerExtraInfo,
      });
      showToast('홈 보기 방식이 변경되었어요.');

      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 0);
    },
    [tracker, changeViewMode],
  );

  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-row p-0.5 rounded-lg" style={{ backgroundColor: Color.Gray200 }}>
        <button
          onClick={() => handleModeChange(HomeSectionViewMode.Default)}
          disabled={!isTextMode}
          className={`${variant.button.base} px-3`}
          style={{
            backgroundColor: !isTextMode ? Color.White : 'transparent',
          }}>
          <CardViewIcon color={!isTextMode ? Color.Gray900 : Color.Gray600} className="size-[20px]" />
          <span className={variant.button.text} style={{ color: !isTextMode ? Color.Gray900 : Color.Gray600 }}>
            표지형
          </span>
        </button>
        <button
          onClick={() => handleModeChange(HomeSectionViewMode.Text)}
          disabled={isTextMode}
          className={`${variant.button.base} px-[7px]`}
          style={{
            backgroundColor: isTextMode ? Color.White : 'transparent',
          }}>
          <ListViewIcon color={isTextMode ? Color.Gray900 : Color.Gray600} className="size-[20px]" />
          <span className={variant.button.text} style={{ color: isTextMode ? Color.Gray900 : Color.Gray600 }}>
            텍스트형
          </span>
        </button>
      </div>
    </div>
  );
});
